module.exports = __webpack_public_path__ + "img/logo_belas_artes_ulisboa.fe0b3a55.png";